/**
 * 添加要加载的组件到加载队列
 * @param {*} comObject 市场组件的对象数据，因为有版本关系，所以优先currentVersion，再取lastVersion，这样做是为了兼容加载页面设置好的组件
 * {
    "id":"component_102003T6YG1GH0L1YFEREQLKK9_inner",
    "packageid":"component_102003T6YG1GH0L1YFEREQLKK9",
    "relationType":"关联到得组件类型，就是组件即将要插入得哪个地方，方便追加到树结构中",
    "relationId":"关联得组件ID",
    "containerIndex":"要添加到组件内部得索引",
    "env":"环境，develop：开发模式，production：预览模式，customize：定制模式",
    "comId":"1",
    "comName":"容器",
    "comType":"vue",
    "asName":"容器",
    "classId":"idm.componet.layout.container",
    "className":"container",
    "iconClass":"idmicon idm-icon-rongqi4",
    "type":"platform",
    "imgList":[
        {
            "src":"~/static/img/demo/dbtablist.jpg",
            "width":1127,
            "height":673,
            "size":"113664"
        }
    ],
    "currentVersion":{
        "version":"1.1.6",
        "projectNo":"p1000",
        "codeSrc":"layout/v1_1_6/static/main.js",
        "datetime":"2021-03-23 12:50:14"
    },
    "lastVersion":{
        "version":"1.1.9",
        "projectNo":"p1000",
        "codeSrc":"layout/v1_1_9/static/main.js",
        "datetime":"2021-03-23 12:50:14"
    },
    "versionList":[
        {
            "version":"1.1.9",
            "projectNo":"p1000",
            "codeSrc":"layout/v1_1_9/static/main.js",
            "datetime":"2021-03-23 12:50:14"
        },
        ...
    ],
    mountComplete:function(){},
    moduleReload:function(){},
    dynamicRenderModuleGroupInitData:function(){},
    removeDynamicRenderModuleGroup:function(){},
    getModuleChildrenPackageId:function(){},
    props:{compositeAttr:{这里就是实际的设置后的属性},innerAttr:{这里就是实际的设置后的组件内的属性}}
    routerId:"路由ID",
    pageid:"页面ID",
    positionMode:"absolute  代表是绝对布局下的组件"
}
 */
function addModuleToQueue(comObject){
    if(!(comObject instanceof Array))
    {
        comObject = [comObject];
    }
    comObject.forEach(item=>{
        var version = item.currentVersion||item.lastVersion||item.versionList[0];
        IDM.module.queue.addModuleMainWaitQueue({
            id:item.id,
            packageid:item.packageid,
            relationType:item.relationType,
            relationId:item.relationId,
            complete:false,//组件代码是否加载完成
            comId:item.comId,
            comName:item.comName,
            comType:item.comType,
            asName:item.asName,
            classId:item.classId,
            className:item.className,
            type:item.type,
            version:version.version,
            codeSrc:version.codeSrc,
            projectNo:version.projectNo,
            datetime:version.datetime,
            callback:IDM.module.moduleLoadedCallback,
            mountComplete:item.mountComplete,
            moduleReload:item.moduleReload,
            dynamicRenderModuleGroupInitData:item.dynamicRenderModuleGroupInitData,
            removeDynamicRenderModuleGroup:item.removeDynamicRenderModuleGroup,
            getModuleChildrenPackageId:item.getModuleChildrenPackageId,
            props:item.props,
            env:item.env,
            routerId:item.routerId,
            pageid:item.pageid,
            positionMode:item.positionMode
        })
    })
    if(!IDM.module.queue.status){
        IDM.module.loadModuleQueue();
    }

}
/**
 * 组件代码加载完成回调事件
 * @param {*} module 
 */
function moduleLoadedCallback(module,innerCallback){
    //循环对比查看是否加载完成
    var isinit = false;
    IDM.module.queue.moduleMain.forEach(item=>{
        if(module.codeSrc==item.codeSrc){
            if(!item._this){
                item._this = this;
            }
            //调用加载组件方法
            !isinit&&window[module.classId+"@"+module.version]&&window[module.classId+"@"+module.version].call(item._this,module);
            item.complete = true;
            isinit = true;
            //组件加载完回调
            // item.mountComplete&&item.mountComplete(item);
        }
    });
    IDM.module.queue.waitModuleCallback.forEach(item=>{
        if(item.codeSrc==module.codeSrc){
            if(!item._this){
                item._this = this;
            }
            window[item.classId+"@"+item.version]&&window[item.classId+"@"+item.version].call(item._this,item);
            //组件加载完回调
            // item.mountComplete&&item.mountComplete(item);
            IDM.module.queue.waitModuleCallback=_.dropWhile(IDM.module.queue.waitModuleCallback,item);
        }
    });
    IDM.module.queue.status = false;
    if(innerCallback!==true){
        IDM.module.loadModuleQueue();
    }
}
/**
 * 执行具体的消息队列，加载完一个后把加载的第一个数组移除，
 * 然后继续调用数组的第一个进行加载，只支持单线程，
 * 当加载完成后移除数组第一个，然后继续执行loadModuleQueue 方法
 * @param {*} mObject 
 */
function loadModuleQueue(){
    IDM.module.queue.status = true;
    var that = IDM.module;
    if(IDM.module.queue.waitModuleMain.length>0){
        var que = IDM.module.queue.waitModuleMain[0];
        var isqueue = false;
        //那已经加载的代码包去对比，如果存在就直接把当前的追加到等待回调队列中
        IDM.module.queue.moduleMain.forEach(item=>{
            if(item.codeSrc==que.codeSrc){
                isqueue = true;
                if(item.complete){
                    //加载完成直接调用回调方法
                    that.moduleLoadedCallback(que,true);
                }else{
                    that.queue.addModuleCallbackQueue(que);
                }
            }
        });
        IDM.module.queue.waitModuleMain=_.drop(IDM.module.queue.waitModuleMain);
        if(!isqueue){
            //追加到已加载队列
            that.queue.addModuleMainQueue(que);

            IDM.module.loadJs(IDM.url.getWebPath("@"+que.codeSrc,"",que.projectNo),false,function(){
                // IDM.module.queue.status = false;
                // that.loadModuleQueue();
            })
        }else if(IDM.module.queue.waitModuleMain.length>0){
            IDM.module.queue.status = false;
            that.loadModuleQueue();
        }
    }else{
        IDM.module.queue.status = false;
    }
}
/**
 * 队列
 */
var queue = {
    /**
     * 队列是否正在执行中
     */
    status:false,
    /**
     * 已加载队列
     * 组件主文件加载队列，加载完一个追加一个，追加前先判断是否存在，如果存在则不添加，直接执行加载这个组件的方法（window[classid].call(this,object)）
     * {
     *  codeSrc:"",
     *  callback:function(module){
     *  }
     * }
     */
    moduleMain:[],
    /**
     * 等候加载的队列
     */
    waitModuleMain:[],
    /**
     * 组件的代码已存在，等候被加载完成调用的组件
     */
    waitModuleCallback:[],
    /**
     * 追加等候加载队列
     */
    addModuleMainWaitQueue:function(object){
        this.waitModuleMain.push(object)
    },
    /**
     * 追加已加载队列
     */
    addModuleMainQueue:function(object){
        this.moduleMain.push(object)
    },
    /**
     * 追加等候被回调的队列
     */
    addModuleCallbackQueue:function(object){
        this.waitModuleCallback.push(object)
    }
}

/**
 * 加载外部js
 * @param {*} src 
 * @param {*} reload 
 * @param {*} fun 
 * @param {async:true,defer:true} option 
 * @returns 
 */
function loadJs(src,reload, fun,option){
    var head = document.getElementsByTagName('head')[0] || document.head || document.documentElement;
    var scriptList = head.getElementsByTagName("script");
    var isExists = false;
    for (let index = 0; index < scriptList.length; index++) {
        const element = scriptList[index];
        if(element.getAttribute("objectID")=="IDM-Module-"+src){
            if(reload){
                $(element).remove();
            }else{
                isExists = true;
            }
        }
    }
    if(isExists){
        //存在则不再次加载js
        fun();
        return;
    }
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('charset', 'UTF-8');
    script.setAttribute('src', src);
    // script.setAttribute('async', false);
    script.setAttribute('objectID', "IDM-Module-"+src);
    if(option&&option.async){
        script.setAttribute('async', "async");
    }
    if(option&&option.defer){
        script.setAttribute('defer', "defer");
    }

    if (typeof fun === 'function') {
        if (window.attachEvent) {
            script.onreadystatechange = function () {
                var r = script.readyState;
                if (r === 'loaded' || r === 'complete') {
                    script.onreadystatechange = null;
                    fun();
                }
            };
        } else {
            script.onload = fun;
        }
    }
    head.appendChild(script);
}
/**
 * 加载外部css
 * @param {*} src 
 * @param {*} reload 
 * @param {*} fun 
 */
function loadCss(src,reload, fun){
    var head = document.getElementsByTagName('head')[0] || document.head || document.documentElement;
    
    var linkList = head.getElementsByTagName("link");
    var isExists = false;
    for (let index = 0; index < linkList.length; index++) {
        const element = linkList[index];
        if(element.getAttribute("objectID")=="IDM-Module-"+src){
            if(reload){
                $(element).remove();
            }else{
                isExists = true;
            }
        }
    }
    if(isExists){
        //存在则不再次加载css
        fun();
        return;
    }

    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', src);
    link.setAttribute('objectID', "IDM-Module-"+src);

    if (typeof fun === 'function') {
        if (window.attachEvent) {
            link.onreadystatechange = function () {
                var r = link.readyState;
                if (r === 'loaded' || r === 'complete') {
                    link.onreadystatechange = null;
                    fun();
                }
            };
        } else {
            link.onload = fun;
        }
    }
    head.appendChild(link);
}
export default {
    loadJs,
    loadCss,
    addModuleToQueue,
    loadModuleQueue,
    moduleLoadedCallback:moduleLoadedCallback,
    queue:queue
}